import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('helpStore', [
      'selectedIPs',
      'confirmedSelectedIPs',
      'submitted',
      'submitting'
    ]),
    ...mapGetters('dataStore', ['selectedASN'])
  },
  methods: {
    ...mapMutations('helpStore', [
      'setSelectedIPs',
      'setConfirmSelected',
      'setSubmitted',
      'clearConfirmSelected'
    ]),
    ...mapActions('helpStore', ['submitForm'])
  }
};
